import * as React from 'react';
import { useSelector } from 'react-redux';
import { ArticleHeading1, Image } from '@cian/ui-kit';
import { InstagramCard } from '../../components/InstagramCard';
import { InstagramSection as InstagramSectionComponent } from '../../components/InstagramSection';
import { getInstagram } from '../../selectors';

export function InstagramSection() {
  const instagramInfo = useSelector(getInstagram);

  const instagramCards = React.useMemo(
    () =>
      instagramInfo.map(item => (
        <InstagramCard
          key={item.id}
          media={<Image src={item.photo.url} alt={item.photo.alt || ''} width={207} height={207} objectFit="cover" />}
          avatar={<Image src={item.avatar} width={40} height={40} borderRadius="50%" objectFit="cover" />}
          userName={item.userName}
        />
      )),
    [instagramInfo],
  );

  if (!instagramInfo || !instagramInfo.length) {
    return null;
  }

  return <InstagramSectionComponent title={<ArticleHeading1>Мы в instagram</ArticleHeading1>} cards={instagramCards} />;
}
